import { createFeatureSelector, createSelector } from "@ngrx/store";
import { currentFeatureKey } from './current-chart.reducer';

export const selectCurrentState = createFeatureSelector(currentFeatureKey);

export const selectCurrent = createSelector(
  selectCurrentState,
  (state: any) => state
);
